module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_6.bb4dbbeb.jpg";